export const removeEmpty = (obj: object) => {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => !['', undefined, null].includes(v)))
}
